goog.provide('el8.uiwidget.PagedTabbedNav');

goog.require('el8.model.base');
goog.require('el8.template.uiwidget.PagedTabbedNav');
goog.require('el8.uiwidget.TabbedNav');

/**
 * A version of the TabbedNav widget with multiple pages of tabs,
 * with navigation amongst them (for displaying more tabs than can
 * fit in a fixed space).
 *
 * See the chart reports dialog for an example usage.
 */
el8.uiwidget.PagedTabbedNav = function() {

    this._pageSize = null;
    this._showingPageIndex = null;

    el8.uiwidget.TabbedNav.prototype.constructor.call(this);
};
el8.uiwidget.PagedTabbedNav.inheritsFrom(el8.uiwidget.TabbedNav);

// Sub-out a custom container function and setup our page nav trigger
el8.uiwidget.PagedTabbedNav.prototype.init = function(opts) {

    opts.tabSectionClass = opts.tabSectionClass || 'el8NewTabSection';

    var that = this;
    opts.containerFn = function() {
        return el8.template.uiwidget.PagedTabbedNav.content({
            tabSectionClass: that._tabSectionClass,
            tabItemClass: that._tabItemClass
        });
    };
    this._pageSize = opts.pageSize;

    el8.uiwidget.TabbedNav.prototype.init.call(this, opts);

    this.container.on('click', '.change-page-trigger',  function() {
        var newIndex = $(this).data('new-index');
        that._showPage(newIndex, true);
    });
};

// When showing a tab, also make sure its containing page is visible
el8.uiwidget.PagedTabbedNav.prototype.showTab = function(name) {

    var $tab = $('.tabbed-nav-item[data-tab="'+name+'"]', this.container);
    var $page = $tab.closest('.tab-page');
    this._showPage($page.data('index'));
    el8.uiwidget.TabbedNav.prototype.showTab.call(this, name);
};

// Decide which page a tab belongs on before adding it,
// including adding a new page if necessary
el8.uiwidget.PagedTabbedNav.prototype.addTab = function(opts) {
    $.extend(opts, {
        tabItemClass: this._tabItemClass,
        tabCountClass: this._tabCountClass
    });
    this.tabSpecList.push(opts);
    opts.hasCount = Boolean(opts.updateCountFn);

    // get (or create) the relevant page
    var $lastTabPage = $('.tab-page', this._container).last();
    if ($('.tabbed-nav-item', $lastTabPage).length >= this._pageSize) {
        var $lastTabPage = this._addPage();
    }

    // add the tab to our chosen page
    $('.tab-list', $lastTabPage).append(this.tabTemplateFn(opts));
    if (opts.tabClass) {
        $('.tabbed-nav-item[data-tab="'+opts.name+'"]', this.container)
            .addClass(opts.tabClass);
    }
    // stuff below is just copied from TabbedNav version
    if (opts.contentDiv) {
        this.tabContentMap[opts.name] = opts.contentDiv;
        this.hideTab(opts.name);
    }
    if (opts.updateCountFn) {
        this.tabUpdateCountFnMap[opts.name] = opts.updateCountFn;
        this.updateTabCount(opts.name);
    }
    if (opts.showTabFn) {
        this.tabShowFnMap[opts.name] = opts.showTabFn;
    }
};

el8.uiwidget.PagedTabbedNav.prototype._addPage = function() {
    var $lastTabPage = $('.tab-page', this._container).last();
    var lastIndex = $lastTabPage.data('index');

    var $newPage = $(el8.template.uiwidget.PagedTabbedNav.tabPage({
        tabSectionClass: this._tabSectionClass,
        tabItemClass: this._tabItemClass,
        index: lastIndex+1
    }));
    $newPage.insertAfter($lastTabPage);

    // next-btns start off hidden... set all of them
    // except the button from this latest page visible
    $('.next-btn-container:not(:last)', this._container).show();

    return $newPage;
};

el8.uiwidget.PagedTabbedNav.prototype._showPage = function(index, showFirstTab) {
    if (this._showingPageIndex === index) { return; }
    var $page = $('.tab-page[data-index="'+index+'"]', this._container);
    if (!$page.length) { return; }

    $('.tab-page', this._container).hide();
    $page.show();
    this._showingPageIndex = index;

    // useful if we're, e.g., switching pages via a next/prev button,
    // to switch to a tab that's actually a member of this page
    if (showFirstTab) {
        var firstTabName = $('.tabbed-nav-item', $page).first().data('tab');
        this.showTab(firstTabName);
    }
};
// no separate _hidePage because for now we always want at least one
// page to be showing, and it's safer to do the hiding implicitly
// while showing the new desired page

el8.uiwidget.PagedTabbedNav.prototype.hideTabButton = function(name) {
    /* Disabled because these functions get used in the standard TabbedNav
     * to pretend a tab doesn't exist (e.g., for feature flags), but that
     * won't work very well here unless the function is page-aware (tabs from
     * the next page should move over). I don't have use for building that yet
     * so I'm just disabling this function as a warning */
};
el8.uiwidget.PagedTabbedNav.prototype.showTabButton = function(name) {
    // disabled (see above)
};
